import './style.scss'
import React from 'react'
import backIcon from 'src/assets/v2/img/back.svg'

export interface BackLinkProps {
    children?: React.ReactNode
    onClick?: () => void
    color?: string
    icon?: React.ReactNode
    className?: string
}

export const BackLink: React.FC<BackLinkProps> = ({
                                                      children = 'Go back', onClick, color = '#344054', icon, className = '',
                                                  }) => (
    <button type="button" className={`back ${className}`} onClick={onClick} style={{ color }}>
        <span className="back__icon">{icon ?? <img src={backIcon} alt="" />}</span>
        <span className="back__label">{children}</span>
    </button>
)

export default BackLink